// extracted by mini-css-extract-plugin
export default {"contentContainer":"Bonus_contentContainer__exurB","translation":"Bonus_translation__wRerJ","checkboxContainer":"Bonus_checkboxContainer__y-OYo"};